export enum NEWS_STORAGE_KEYS {
  DealerPreference = "news-dealer-preference",
  DatePreference = "news-date-preference",
  CategoryPreference = "news-category-preference",
  PageSizePreference = "news-page-size-preference",
  PublishedDatePreference = "news-published-date-preference",
  LanguagePreference = "news-language-preference"
}
